import { put, takeEvery } from 'redux-saga/effects'
import {APP_INIT} from '../constants/actionTypes';
import { getHostingElementProps } from '../services/onsiteService';
import { initHostingElement } from '../actions/embeddedFormActions';

function* embeddedFormSagaInitHandler() {
  try {
    const elementProps = getHostingElementProps();
    yield(put(initHostingElement(elementProps)));
  } catch (e) {
    console.warn(e);
    yield put(initHostingElement({}));
  }
}

function* embeddedFormSaga() {  
  yield takeEvery(APP_INIT, embeddedFormSagaInitHandler);
}

export default embeddedFormSaga;
